import { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import clienteAuthService from '../api/authService';

export default function ClienteResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [form, setForm] = useState({
    email: searchParams.get('email') || '',
    password: '',
    password_confirmation: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) setError('Link non valido o scaduto.');
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password !== form.password_confirmation) {
      setError('Le password non corrispondono.');
      return;
    }
    setLoading(true);
    try {
      await clienteAuthService.resetPassword(token, form.email, form.password, form.password_confirmation);
      setSuccess('Password aggiornata! Reindirizzamento al login…');
      setTimeout(() => navigate('/area-riservata/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Link scaduto o non valido.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FFFEFA] flex items-center justify-center px-4">
      <div className="w-full max-w-md mang-card p-8">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Reimposta password</h1>
        {success && <div className="bg-green-50 text-green-700 text-sm p-3 rounded-lg mb-4">{success}</div>}
        {error && <div className="bg-red-50 text-red-700 text-sm p-3 rounded-lg mb-4">{error}</div>}
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">Email</label>
            <input type="email" required className="w-full border rounded-xl px-4 py-2.5" value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Nuova password</label>
            <input type="password" required minLength={8} className="w-full border rounded-xl px-4 py-2.5"
              value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Conferma password</label>
            <input type="password" required minLength={8} className="w-full border rounded-xl px-4 py-2.5"
              value={form.password_confirmation} onChange={(e) => setForm({ ...form, password_confirmation: e.target.value })} />
          </div>
          <button type="submit" disabled={loading || !token}
            className="w-full bg-[#c78244] text-white py-3 rounded-xl font-semibold hover:opacity-90 disabled:opacity-50">
            {loading ? 'Salvataggio…' : 'Salva nuova password'}
          </button>
        </form>
        <p className="text-center text-sm text-gray-500 mt-4">
          <Link to="/area-riservata/login" className="text-[#c78244] underline">← Torna al login</Link>
        </p>
      </div>
    </div>
  );
}
